import { Default, Detail, List } from "./views";
import { ApplyAction } from "./wizards";

const Module = {
    name: "synchronizableleads",
    defaultRoutePath: "/synchronizableleads/leadmargo",
    menuItemScope: "synchronizable",
    menuItemName: "leadMargos",
    routes: [{
        path: "/synchronizableleads/leadmargo",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "applyAction",
            Component: ApplyAction,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        // {
        //     path: "create",
        //     Component: Create,
        // },
    ],
    
}

export default Module;
